import axios from 'axios';
import { SERVER_URL } from '../App';

function withCredentialsConfig(config = {}) {
    return {
        withCredentials: true,
        ...config,
    };
}

export async function fetchAuthMe() {
    const { data } = await axios.get(`${SERVER_URL()}auth/me`, withCredentialsConfig());
    return data;
}

export async function fetchAdminAnalytics(days) {
    const suffix = days ? `?days=${encodeURIComponent(days)}` : '';
    const { data } = await axios.get(`${SERVER_URL()}admin-analytics${suffix}`, withCredentialsConfig());
    return data;
}

export async function fetchAdminActivity({ limit, kind, before, until } = {}) {
    const params = new URLSearchParams();
    if (limit) params.set('limit', String(limit));
    if (kind && kind !== 'all') params.set('kind', kind);
    if (before) params.set('before', String(before));
    if (until) params.set('until', String(until));
    const query = params.toString();
    const { data } = await axios.get(
        `${SERVER_URL()}admin-activity${query ? `?${query}` : ''}`,
        withCredentialsConfig(),
    );
    return data;
}

export async function logoutAccount() {
    const { data } = await axios.post(
        `${SERVER_URL()}auth/logout`,
        {},
        withCredentialsConfig({
            headers: { 'Content-Type': 'application/json' },
        })
    );
    return data;
}

// `src` marks where the login started so the callback can attribute the signup
// (only the guest cap gate sets it, as 'cap_gate').
export function buildDiscordLoginUrl(nextPath, src) {
    const next = nextPath || window.location.pathname || '/fr/gen';
    const suffix = src ? `&src=${encodeURIComponent(src)}` : '';
    return `${SERVER_URL()}auth/discord/start?next=${encodeURIComponent(next)}${suffix}`;
}

